<template>
  <div v-if="show" class="popupWrap" @touchmove="onTouchMove" @focusout="onBlur">
    <div v-show="show && showMask" class="mask" @click="close"></div>
    <div v-show="show" class="popupBox" @click="close">
      <div class="popupContent" @click.stop>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, computed, watch, onUpdated, onUnmounted } from "vue";

const props = defineProps({
  //是否显示
  value: {
    type: Boolean,
    default: true,
  },
  //弹窗动画
  dialogTransition: {
    type: String,
    default: "slide-fade",
  },
  //点击遮罩层关闭弹窗
  hideForMask: {
    type: Boolean,
    default: true,
  },
  //禁止页面滚动
  scroll: {
    type: Boolean,
    default: true,
  },
  // 是否显示蒙层
  showMask: {
    type: Boolean,
    default: true,
  },
  // 自动关闭时间，设置为0不自动关闭
  autoHide: {
    type: Number,
    default: 0,
  },
});
const emit = defineEmits(["input"]);

let scrollTop = ref(0);
const show = computed(() => props.value);

let closeTimer = 0;
watch(show, function (value) {
  if (value && props.autoHide > 0) {
    closeTimer = window.setTimeout(
      () => {
        emit("input", false);
        // 如果不小心当作秒来传递的，则也能接收并处理
      },
      props.autoHide < 10 ? props.autoHide * 1000 : props.autoHide
    );
  }
  if (!value) {
    closeTimer && clearTimeout(closeTimer);
  }
});

onUpdated(function () {
  scrollTop.value =
    document.documentElement.scrollTop || document.body.scrollTop;
});

onUnmounted(function () {
  closeTimer && clearTimeout(closeTimer);
});

const onTouchMove = function (event: TouchEvent) {
  !props.scroll && event.preventDefault();
};
const onBlur = function () {
  try { 
    if (navigator.userAgent && navigator.userAgent.toLowerCase().indexOf("iphone") > 0) {
      window.scrollTo(0, scrollTop.value);
    }
  } catch (error) {
    console.log(error)
  }
};
const close = function () {
  if (props.hideForMask) {
    emit("input", false);
  }
};
</script>

<style lang="less" scoped>
.popupWrap {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 50;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  transform: translateY(0%);
}

/* 遮罩层 */
.mask {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(2px);
}

.popupBox {
  position: relative;
  z-index: 2;
}

.popupContent {
  max-height: 100vh;
  margin: auto;
  background: transparent;
}
</style>
